import React from "react";
import "./Navbar.css"
import Logo from "../../img/Mindpunch Logo.jpg"
import MinecraftButton from "../minecraft_button/Minecraft_Button";

function Navbar() {
    return ( <div className="navbar-container"> 
        
        <div className="navigation-container">
            <img className="logo" src={Logo} alt="outline in the shape of a brain with a fist in the middle" title="Mindpunch"/>
            {/* <Link className="nav-item" to="/">
                Home
            </Link> */}
            <MinecraftButton to="/" label="Home" />

            <MinecraftButton to="history/" label="Our History"/>
            
            <MinecraftButton to="members/" label="Members"/>

            <MinecraftButton to="notable-events/" label="Notable Events"/>

            <MinecraftButton to="build-highlights/" label="Build Highlights"/>

        </div>
        <div className="user-container">
            <span className="nav-item">
                Login
            </span>
            <span className="nav-item">
                Sign Up
            </span>
        </div>
    </div>


    );

}

export default Navbar;